export const ClickToEditNoButtonsDirective = ['ClickToEditFactory', function(ClickToEditFactory) {
   return ClickToEditFactory.get('input', false);
}];
